import axios_ from "../utils/axios";
import qs from "qs";
import {usePyConfig as useConfig} from "./usePyConfig";
import exportWithSign from "@/utils/exportWithSign";


/**
 * @param {string} path
 * @param {Record<string,any>} query
 */
function useExport(path, query) {
  query.token = localStorage.getItem("token") || "";
  const url = `${process.env.VUE_APP_PY_CN_API_URL}${path}?${qs.stringify(query)}`;
  window.open(url);
}

/**
 * 社媒监控主页详情
 */
export default {
  /**
   * 获取各平台主页信息
   * @param {string} page_id 主页ID
   * @param {string} platform 平台
   * @returns {Promise<DefaultResponseType>}
   */
  get_page_detail(page_id, platform) {
    return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/page_info/page_detail", { page_id, platform })));
  },

  /**
   * 单一贴文信息
   * @param page_id 主页ID
   * @param platform 平台
   * @param post_id 贴文ID
   * @returns {Promise<DefaultResponseType>}
   */
  page_post_detail(page_id, platform, post_id) {
    return axios_(
      ...Object.values(useConfig("GET", "api/pandagpt/v1/page_info/page_post_detail", { page_id, platform, post_id }))
    );
  },

  /**
   * youtube 授权回调
   * @param {Record<string,string>} query
   * @return {Promise<DefaultResponseType<boolean>>}
   */
  youtube_callback(query) {
    return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/youtube/callback", query)));
  },
  /**
   * 社媒详情页各平台表格总计数据
   */
  stat_media: {
    /**
     * 获取当前平台、当前 tab 下表格的总计数据
     * @param {{page_id:string; platform:string; tab:string; start_date:string; end_date:string}} query
     * @returns {Promise<DefaultResponseType>}
     */
    retrieve(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/stat_media/retrieve", query)));
    },
    /**
     * 获取主页更新状态，详情页顶部更新时间和按钮 loading 都从这里取。
     * @param {{page_id:string; platform:string; token_valid?:1|2; post_id?:string}} query
     * @returns {Promise<DefaultResponseType>}
     */
    refresh_status(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/stat_media/refresh_status", query)));
    },
    /**
     * 触发主页数据刷新，详情页“更新数据”弹层确认按钮调用这里。
     * @param {{page_id:string; platform:string|number; start_date:string; end_date:string; post_id?:string}} query
     * @returns {Promise<DefaultResponseType>}
     */
    refresh_data(query) {
      return axios_(...Object.values(useConfig("POST", "api/pandagpt/v1/stat_media/refresh_data", query)));
    },
  },
  /**
   * facebook 主页统计
   */
  facebook_main_page: {
    // /**
    //  * 获取facebook详情主页赞
    //  * @param {{page_id:string;start_date:string;end_date:string;period:string;data_type:string}} query
    //  * @returns {Promise<DefaultResponseType>}
    //  */
    // page_fans_query(query) {
    //   let config = {
    //     method: "GET",
    //     url: "api/pandagpt/v1/m/facebook_page/page_fans_query",
    //     params: query,
    //     noCancelable: false,
    //     isFormData: false,
    //     isPyRequest: true,
    //     isFPyRequest: false,
    //   };
    //   return axios_(...Object.values(config));
    // },
    /**
     * Facebook 主页详情中的千粉互动
     * @param {{page_id:string; start_date:string;end_date:string;data_type:string}} query
     * @param query.page_id
     * @param query.start_date
     * @param query.end_date
     * @param query.data_type 数据类型：1 授权数据，2 公开数据
     * @returns {Promise<DefaultResponseType>}
     */
    interaction_per_1000_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_page/interaction_per_1000_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Facebook 主页详情中的主页互动次数。
     * @param {{page_id:string; start_date:string; end_date:string}} query
     * @returns {Promise<DefaultResponseType>}
     */
    page_post_engagements_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_page/page_post_engagements_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Facebook 主页详情中的访问量。
     * @param {{page_id:string; start_date:string; end_date:string; period:string}} query
     * @param query.period 时间维度：1 日，2 周，3 月
     * @returns {Promise<DefaultResponseType>}
     */
    page_views_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_page/page_views_total_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Facebook 主页详情中的视频播放次数。
     * @param {{page_id:string; start_date:string; end_date:string; period:string}} query
     * @returns {Promise<DefaultResponseType>}
     */
    page_video_views_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_page/page_video_views_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Facebook 主页详情中的主页视频播放 30 秒次数。
     * @param {{page_id:string; start_date:string; end_date:string; period:string}} query
     * @returns {Promise<DefaultResponseType>}
     */
    page_video_complete_views_30s_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_page/page_video_complete_views_30s_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 主页详情中的帖文心情
     * @param {{page_id:string; start_date:string;end_date:string;data_type:string}} query
     * @param query.page_id
     * @param query.start_date
     * @param query.end_date
     * @param query.data_type 数据类型：1 授权数据，2 公开数据
     * @returns {Promise<DefaultResponseType>}
     */
    reactions_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_page/reactions_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 主页详情中的主页曝光次数
     * @param {{page_id:string; start_date:string;end_date:string;period:string}} query
     * @param query.page_id
     * @param query.start_date
     * @param query.end_date
     * @param query.period 时间维度：1 日，2 周，3 月
     * @returns {Promise<DefaultResponseType>}
     */
    impressions_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_page/impressions_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Facebook 主页详情中的主页覆盖人数
     * @param {{page_id:string; start_date:string;end_date:string;period:string}} query
     * @param query.page_id
     * @param query.start_date
     * @param query.end_date
     * @param query.period 时间维度：1 日，2 周，3 月
     * @returns {Promise<DefaultResponseType>}
     */
    impressions_unique_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_page/impressions_unique_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 主页详情中的数据详情
     * @param {{page_id:string;start_date:string;end_date:string;page:number;page_num:number;}} query
     * @return {Promise<DefaultResponseType>}
     */
    data_detail(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_page/data_detail",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Facebook 主页详情中的数据详情 导出
     * @param {{page_id:string;start_date:string;end_date:string}} query
     */
    export_data_detail(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/facebook_page/export_data_detail?${qs.stringify(query)}`;

      window.open(url);
    },
  },
  facebook_fans_page: {
    /**
     * facebook详情 粉丝趋势
     * @param {{page_id:string;start_date:string;end_date:string;period:string;data_type:string}} query
     * @returns {Promise<DefaultResponseType>}
     */
    page_follows_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_follows/page_follows_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * facebook详情 国家分布
     * @param {{page_id:string;start_date:string;end_date:string}} query
     * @returns {Promise<DefaultResponseType>}
     */
    page_fans_country(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_follows/page_fans_country",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * facebook详情 城市分布
     */
    page_fans_city(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_follows/page_fans_city",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    // /**
    //  * facebook详情 语言分布
    //  */
    // page_fans_locale(query) {
    //   let config = {
    //     method: "GET",
    //     url: "api/pandagpt/v1/m/facebook_follows/page_fans_locale",
    //     params: query,
    //     noCancelable: false,
    //     isFormData: false,
    //     isPyRequest: true,
    //     isFPyRequest: false,
    //   };
    //   return axios_(...Object.values(config));
    // },
    /**
     * facebook 粉丝数据详情
     */
    data_detail(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_follows/data_detail",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Facebook 粉丝数据中的国家分布导出
     * @param {{page_id:string;start_date:string;end_date:string;token?:string}} query
     */
    export_page_fans_country(query) {
      // 导出接口与旧详情页保持同一地址，token 由 API 层统一补充。
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/facebook_follows/export_page_fans_country?${qs.stringify(query)}`;
      window.open(url);
    },
    /**
     * Facebook 粉丝数据中的城市分布导出
     * @param {{page_id:string;start_date:string;end_date:string;token?:string}} query
     */
    export_page_fans_city(query) {
      // 城市报表和页面当前的主页、日期范围保持一致。
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/facebook_follows/export_page_fans_city?${qs.stringify(query)}`;
      window.open(url);
    },
    /**
     * Facebook 粉丝数据详情导出
     * @param {{page_id:string;start_date:string;end_date:string;sort_field?:string;sort_order?:string;token?:string}} query
     */
    export_data_detail(query) {
      // 汇总表导出不携带分页参数，保证下载完整日期范围的明细。
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/facebook_follows/export_data_detail?${qs.stringify(query)}`;
      window.open(url);
    },
  },
  facebook_post_page: {
    /**
     * @returns {Promise<DefaultResponseType>}
     */
    post_count_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_posts/post_count_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    post_engagements(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_posts/post_engagements",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * 获取发帖和贴文互动趋势
     * @param {{page_id:string;start_date:string;end_date:string;period:string; data_type:string}} query
     * @param {string} query.page_id
     * @param {string} query.start_date
     * @param {string} query.end_date
     * @param {string} query.period 时间维度 1 日 2 周 3 月
     * @param {string} query.data_type 1 授权数据 2 公开数据
     * @returns {Promise<DefaultResponseType>}
     */
    post_count_and_engagements(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_posts/post_count_and_engagements",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 帖文曝光
     * @param {{page_id:string;start_date:string;end_date:string;period:string;}} query
     * @param {string} query.page_id
     * @param {string} query.start_date
     * @param {string} query.end_date
     * @param {string} query.period 时间维度 1 日 2 周 3 月
     * @returns {Promise<DefaultResponseType>}
     */
    post_impressions(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_posts/post_impressions",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    // /**
    //  * Facebook 帖文覆盖人数
    //  * @param {{page_id:string;start_date:string;end_date:string;period:string;}} query
    //  * @param {string} query.page_id
    //  * @param {string} query.start_date
    //  * @param {string} query.end_date
    //  * @param {string} query.period 时间维度 1 日 2 周 3 月
    //  * @returns {Promise<DefaultResponseType>}
    //  */
    // post_impressions_unique(query) {
    //   let config = {
    //     method: "GET",
    //     url: "api/pandagpt/v1/m/facebook_posts/post_impressions_unique",
    //     params: query,
    //     noCancelable: false,
    //     isFormData: false,
    //     isPyRequest: true,
    //     isFPyRequest: false,
    //   };
    //   return axios_(...Object.values(config));
    // },

    // /**
    //  * Facebook 视频观看人数
    //  * @param {{page_id:string;start_date:string;end_date:string;period:string;}} query
    //  * @param {string} query.page_id
    //  * @param {string} query.start_date
    //  * @param {string} query.end_date
    //  * @param {string} query.period 时间维度 1 日 2 周 3 月
    //  * @returns {Promise<DefaultResponseType>}
    //  */
    // post_video_views_unique(query) {
    //   let config = {
    //     method: "GET",
    //     url: "api/pandagpt/v1/m/facebook_posts/post_video_views_unique",
    //     params: query,
    //     noCancelable: false,
    //     isFormData: false,
    //     isPyRequest: true,
    //     isFPyRequest: false,
    //   };
    //   return axios_(...Object.values(config));
    // },

    /**
     * Facebook 视频观看次数
     * @param {{page_id:string;start_date:string;end_date:string;period:string;}} query
     * @param {string} query.page_id
     * @param {string} query.start_date
     * @param {string} query.end_date
     * @param {string} query.period 时间维度 1 日 2 周 3 月
     * @returns {Promise<DefaultResponseType>}
     */
    post_video_views(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_posts/post_video_views",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 主页详情中的视频播放30秒次数
     * @param {{page_id:string;start_date:string;end_date:string;period:string;}} query
     * @param {string} query.page_id
     * @param {string} query.start_date
     * @param {string} query.end_date
     * @param {string} query.period 时间维度 1 日 2 周 3 月
     * @returns {Promise<DefaultResponseType>}
     */
    post_video_complete_views_30s(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_posts/post_video_complete_views_30s",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 视频观看时长及播放方式
     * @param {{page_id:string;start_date:string;end_date:string;}} query
     * @param {string} query.page_id
     * @param {string} query.start_date
     * @param {string} query.end_date
     * @returns {Promise<DefaultResponseType>}
     */
    post_video_view_time(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_posts/post_video_view_time",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 评论趋势
     * @param {{page_id:string;start_date:string;end_date:string;}} query
     * @param {string} query.page_id
     * @param {string} query.start_date
     * @param {string} query.end_date
     * @returns {Promise<DefaultResponseType>}
     */
    comment_trend(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_posts/comment_trend",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 点击次数
     * @param {{page_id:string;start_date:string;end_date:string;}} query
     * @param {string} query.page_id
     * @param {string} query.start_date
     * @param {string} query.end_date
     * @returns {Promise<DefaultResponseType>}
     */
    click_count(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_posts/click_count",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 贴文数据详情
     * @param {{page_id:string;start_date:string;end_date:string;page:number; page_num:number;sort_field:string; sort_order:string}} query
     * @param {string} query.page_id
     * @param {string} query.start_date
     * @param {string} query.end_date
     * @param {number} query.page 当前页数
     * @param {number} query.page_num 分页大小
     * @param {string} query.sort_field 排序字段
     * @param {string} query.sort_order 排序方式（asc:升序 desc:降序）
     * @returns {Promise<DefaultResponseType>}
     */
    data_detail(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_posts/data_detail",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 贴文数据详情导出
     * @param {{page_id:string;start_date:string;end_date:string;page:number; page_num:number;sort_field:string; sort_order:string}} query
     * @param {string} query.page_id
     * @param {string} query.start_date
     * @param {string} query.end_date
     */
    export_data_detail(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/facebook_posts/export_data_detail?${qs.stringify(query)}`;

      window.open(url);
    },
  },
  facebook_signal_post_page: {
    /**
     * 单一贴文列表
     * @param query
     * @returns {Promise<*|undefined>}
     */
    post_list(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_single_posts/post_list",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * 单一帖文列表导出
     * @param query
     * @returns {Promise<*|undefined>}
     */
    export_post_list(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/facebook_single_posts/export_post_list?${qs.stringify(query)}`;
      window.open(url);
    },

    /**
     * 单一帖文数据-标准
     * @param post_id 帖文ID
     * @param data_type 数据类型：1 授权数据，2 公开数据
     * @returns {Promise<*|undefined>}
     */
    standard_data(post_id, data_type) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_single_posts/standard_data",
        params: { post_id, data_type },
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 单一帖文下钻评论列表。
     * @param {{page_id:string|number;post_id:string;start_date?:string;end_date?:string;page?:number;page_num?:number;comment_analyze?:1|2|3;comment_content?:string;reply_status?:0|1}} query
     * @returns {Promise<*|undefined>}
     */
    comment_list(query) {
      // 评论列表属于 Facebook 单一帖文下钻，先放在当前分组里，后续评论接口多了再单独拆分 comments 分组。
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/facebook_comments/comment_list",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 单一帖文下钻评论列表导出。
     * @param {{page_id:string|number;post_id:string;start_date?:string;end_date?:string;comment_analyze?:1|2|3;comment_content?:string;reply_status?:0|1}} query
     */
    export_comment_list(query) {
      // 导出接口和评论列表保持同一入参口径，token 仍按项目已有导出方式拼到 query 上。
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/facebook_comments/export_comment_list?${qs.stringify(query)}`;
      window.open(url);
    },

    /**
     * Facebook 评论翻译。
     * @param {{content:string}} data
     * @returns {Promise<*|undefined>}
     */
    translate_comment(data) {
      // 评论翻译目前只服务 Facebook 单帖评论，先跟评论列表接口放在同一分组里。
      let config = {
        method: "POST",
        url: "api/pandagpt/v1/m/facebook_comments/translate",
        params: data,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 评论隐藏/取消隐藏。
     * @param {{page_id:string|number;comment_id:string;is_hidden?:0|1}} data
     * @returns {Promise<*|undefined>}
     */
    hide_comment(data) {
      // 隐藏状态操作属于评论行操作，继续和评论列表、翻译接口放在同一分组里。
      let config = {
        method: "POST",
        url: "api/pandagpt/v1/m/facebook_comments/hide",
        params: data,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 删除评论。
     * @param {{page_id:string|number;comment_id:string}} data
     * @returns {Promise<*|undefined>}
     */
    delete_comment(data) {
      // 删除评论同样是单帖评论行操作，和 hide_comment 保持同一调用分组。
      let config = {
        method: "POST",
        url: "api/pandagpt/v1/m/facebook_comments/delete",
        params: data,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Facebook 回复评论。
     * @param {{page_id:string|number;post_id:string;comment_id:string;content:string}} data
     * @returns {Promise<*|undefined>}
     */
    add_comment(data) {
      // 回复评论接口命名跟后端 add 保持对应，页面调用时仍在评论分组下统一管理。
      let config = {
        method: "POST",
        url: "api/pandagpt/v1/m/facebook_comments/add",
        params: data,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
  },
  tiktok_main_page: {
    /**
     * tiktok主页资料查看人数数据
     * @param {{page_id:string;start_date:string;end_date:string;time_dimension:'day'|'week'|'month'}} query
     * @returns {Promise<DefaultResponseType>}
     */
    get_tiktok_infor_insights(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/stat_media/get_tiktok_infor_insights", query)));
    },

    /**
     * tiktok主页视频观看次数
     * @param {{page_id:string;start_date:string;end_date:string;time_dimension:'day'|'week'|'month'}} query
     * @returns {Promise<DefaultResponseType>}
     */
    get_tiktok_video_views_insights(query) {
      return axios_(
        ...Object.values(useConfig("GET", "api/pandagpt/v1/stat_media/get_tiktok_video_views_insights", query))
      );
    },

    /**
     * tiktok主页观众数量
     * @param {{page_id:string;start_date:string;end_date:string;time_dimension:'day'|'week'|'month'}} query
     * @returns {Promise<DefaultResponseType>}
     */
    get_tiktok_audience_insights(query) {
      // 观众数量模块使用独立 audience insights 接口，参数结构和其它主页趋势接口保持一致。
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/stat_media/get_tiktok_audience_insights", query)));
    },

    /**
     * tiktok主页互动观众数量
     * @param {{page_id:string;start_date:string;end_date:string;time_dimension:'day'|'week'|'month'}} query
     * @returns {Promise<DefaultResponseType>}
     */
    get_tiktok_interaction_audience(query) {
      // 互动观众数量使用独立接口，不能复用 audience insights 的 data_type 参数。
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/stat_media/get_tiktok_interaction_audience", query)));
    },

    /**
     * tiktok主页互动数
     * @param {{page_id:string;start_date:string;end_date:string;time_dimension:'day'|'week'|'month'}} query
     * @returns {Promise<DefaultResponseType>}
     */
    get_tiktok_interaction_insights(query) {
      // 主页互动数使用新版 get_tiktok_interaction_insights 接口，区别于帖文互动接口。
      return axios_(
        ...Object.values(useConfig("GET", "api/pandagpt/v1/stat_media/get_tiktok_interaction_insights", query))
      );
    },

    /**
     * TikTok主页每日成效数据列表接口
     * @param {{page_id:string;page:number; page_num:number; start_date:string; end_date:string;}} query
     * @returns {Promise<DefaultResponseType>}
     */
    list_tiktok_page_insights(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/stat_media/list_tiktok_page_insights", query)));
    },
    /**
     * tiktok主页详情导出
     * @param {{page_id:string;start_date:string;end_date:string;[k:string]:any}} query
     */
    export_tiktok_page_insights(query) {
      useExport("api/pandagpt/v1/stat_media/export_tiktok_page_insights", query);
    },
  },
  tiktok_fans_page: {
    /**
     * tiktok粉丝数
     * @returns {Promise<DefaultResponseType>}
     */
    get_tiktok_fans_insights(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_fans_insights",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * tiktok 粉丝国家分布
     * @returns {Promise<DefaultResponseType>}
     */
    get_tiktok_fans_country_insights(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_fans_country_insights",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * tiktok 粉丝城市分布
     * @returns {Promise<DefaultResponseType>}
     */
    get_tiktok_fans_city_insights(query) {
      // 粉丝城市分布使用 stat_media 新接口，和国家分布保持相同入参结构。
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_fans_city_insights",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * tiktok 性别分布
     * @returns {Promise<DefaultResponseType>}
     */
    get_tiktok_fans_gender_insights(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_fans_gender_insights",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * tiktok 年龄分布
     * @returns {Promise<DefaultResponseType>}
     */
    get_tiktok_fans_age_insights(query) {
      // 粉丝年龄分布使用独立接口，入参和性别分布保持一致。
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_fans_age_insights",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * tiktok 在线时间
     * @returns {Promise<DefaultResponseType>}
     */
    get_tiktok_fans_activity_insights(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_fans_activity_insights",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * tiktok粉丝数据详情列表
     * @param {{page_id:string;page:number; page_num:number; start_date:string; end_date:string;}} query
     * @returns {Promise<DefaultResponseType>}
     */
    get_tiktok_fans_detail_lists(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_fans_detail_lists",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * tiktok粉丝数据国家分布导出报表
     * @param {{page_id:string;start_date:string;end_date:string;[k:string]:any}} query
     */
    export_tiktok_fans_country_insights(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/stat_media/export_tiktok_fans_country_insights?${qs.stringify(query)}`;
      window.open(url);
    },
    /**
     * tiktok粉丝数据城市分布导出报表
     * @param {{page_id:string;start_date:string;end_date:string;[k:string]:any}} query
     */
    export_tiktok_fans_city_insights(query) {
      // 城市分布导出沿用 stat_media 的 export 命名，方便粉丝 tab 组件直接复用。
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/stat_media/export_tiktok_fans_city_insights?${qs.stringify(query)}`;
      window.open(url);
    },
    /**
     * tiktok粉丝性别分布报表导出
     * @param {{page_id:string;start_date:string;end_date:string;[k:string]:any}} query
     */
    export_tiktok_fans_gender_insights(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/stat_media/export_tiktok_fans_gender_insights?${qs.stringify(query)}`;
      window.open(url);
    },
    /**
     * TikTok粉丝在线时间数据导出
     * @param {{page_id:string;start_date:string;end_date:string;[k:string]:any}} query
     */
    export_tiktok_fans_activity_insights(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/stat_media/export_tiktok_fans_activity_insights?${qs.stringify(query)}`;
      window.open(url);
    },
    /**
     * tiktok粉丝数据详情导出
     * @param {{page_id:string;start_date:string;end_date:string;[k:string]:any}} query
     */
    export_tiktok_fans_detail_lists(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/stat_media/export_tiktok_fans_detail_lists?${qs.stringify(query)}`;
      window.open(url);
    },
  },
  tiktok_posts: {
    /**
     * tiktok帖文发视频数
     * @param {{
     *     page_id:string;
     *     start_date:string;
     *     end_date:string;
     *     time_dimension:'day'|'week'|'month'
     * }} query
     * @return {Promise<DefaultResponseType<{chart_data:{x_axis:string; y_axis:number; tooltip:string}[]; summary:Record<string,string|number>;}|[]>>}
     */
    get_tiktok_send_video_number(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_send_video_number",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * tiktok帖文曝光次数
     * @param {{
     *     page_id:string;
     *     start_date:string;
     *     end_date:string;
     *     time_dimension:'day'|'week'|'month'
     * }} query
     * @return {Promise<DefaultResponseType<{summary:Record<string, number|string>; chart_data:Record[]}|[]>>}
     */
    get_tiktok_exposure_insights(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_exposure_insights",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * tiktok帖文互动次数
     * @param {{
     *     page_id:string;
     *     start_date:string;
     *     end_date:string;
     *     time_dimension:'day'|'week'|'month'
     * }} query
     * @return {Promise<DefaultResponseType<[]|{summary:object; chart_data:Record}>>}
     */
    get_tiktok_video_interaction_insights(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_video_interaction_insights",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * tiktok帖文互动次数及粉丝互动率趋势
     * @param {{
     *     page_id:string;
     *     start_date:string;
     *     end_date:string;
     *     time_dimension:'day'|'week'|'month'
     * }} query
     * @return {Promise<DefaultResponseType>}
     */
    get_tiktok_interaction_fans(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_interaction_fans",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * tiktok 帖文 视频观看及互动趋势接口文档
     * @param {{
     *     page_id: string
     *     start_date: string
     *     end_date: string
     *     time_dimension: 'day'|'month'|'week'
     *     trend_chart: 'interaction_count'|'interaction_rate'|'completion_rate'
     * }} query
     * @return {Promise<DefaultResponseType<[]|{summary:Record; chart_data:Record<string,number>[]}>>}
     */
    get_tiktok_watching_interaction(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_watching_interaction",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * tiktok 帖文覆盖人数
     * @param {{
     *     page_id:string;
     *     start_date:string;
     *     end_date:string;
     *     time_dimension:'day'|'week'|'month'
     * }} query
     * @return {Promise<DefaultResponseType<[]|{
     *     summary: Record<string, number>;
     *     chart_data:Record<string,any>[];
     * }>>}
     */
    get_tiktok_people_covered(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_people_covered",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * tiktok视频观看时长
     * @param {{
     *     page_id:string;
     *     start_date:string;
     *     end_date:string;
     *     time_dimension:'day'|'week'|'month'
     * }} query
     * @return {Promise<DefaultResponseType<[]|{summary:Record<string,number>; chart_data:Record[]}>>}
     */
    get_tiktok_video_viewing_duration(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_video_viewing_duration",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * TikTok评论趋势统计
     * @param {{
     *     page_id:string;
     *     start_date:string;
     *     end_date:string;
     * }} query
     * @return {Promise<DefaultResponseType<[]|{summary:Record<string,number>; chart_data:Record[]}>>}
     */
    get_tiktok_comment_trends(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_comment_trends",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * 获取tiktok帖文详情表格
     * @param {{
     *     page_id:string;
     *     start_date:string;
     *     end_date:string;
     *     page:number;
     *     page_num:number;
     *     sort_field:string;
     *     sort_order:string
     * }} query
     * @return {Promise<DefaultResponseType<{data:Record<string,any>; total:number}>>}
     */
    get_tiktok_data_details(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_tiktok_data_details",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * 导出tiktok贴文详情表格
     * @param query
     */
    export_tiktok_data_detail(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/stat_media/export_tiktok_data_detail?${qs.stringify(query)}`;
      window.open(url);
    },
    /**
     * tiktok 视频流量来源
     * @return {Promise<DefaultResponseType>}
     */
    get_top_sources(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_top_sources",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * 导出tiktok视频流量来源
     */
    export_top_sources(query) {
      const baseURL = process.env.VUE_APP_PY_CN_API_URL;
      query.token = localStorage.getItem("token") || "";
      window.open(`${baseURL}api/pandagpt/v1/stat_media/export_top_sources?${qs.stringify(query)}`);
    },
    /**
     * tiktok 观众来源
     * @return {Promise<DefaultResponseType>}
     */
    get_top_countries(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_top_countries",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * 导出tiktok观众来源
     */
    export_top_countries(query) {
      const baseURL = process.env.VUE_APP_PY_CN_API_URL;
      query.token = localStorage.getItem("token") || "";
      window.open(`${baseURL}api/pandagpt/v1/stat_media/export_top_countries?${qs.stringify(query)}`);
    },
    /**
     * 获取创作偏好数据
     * @param query
     * @returns {Promise<{
     *    get_top_hashtags:any;
     *    get_top_musics:any;
     *    get_top_mentioned_users:any;
     *    get_top_url_mentions:any;
     *    get_video_duration_stats:any;
     *    video_release_timing:any;
     * }>}
     */
    async getCreativePreferences(query) {
      /**
       * 使用最多的话题标签
       * @type {Promise<DefaultResponseType>}
       */
      const get_top_hashtags = axios_(
        ...Object.values({
          method: "GET",
          url: "api/pandagpt/v1/stat_media/get_top_hashtags",
          params: query,
          noCancelable: false,
          isFormData: false,
          isPyRequest: true,
          isFPyRequest: false,
        })
      );
      /**
       * 提及最多用户
       * @type {Promise<DefaultResponseType>}
       */
      const get_top_mentioned_users = axios_(
        ...Object.values({
          method: "GET",
          url: "api/pandagpt/v1/stat_media/get_top_mentioned_users",
          params: query,
          noCancelable: false,
          isFormData: false,
          isPyRequest: true,
          isFPyRequest: false,
        })
      );
      /**
       * 使用最多的声音
       * @type {Promise<DefaultResponseType>}
       */
      const get_top_musics = axios_(
        ...Object.values({
          method: "GET",
          url: "api/pandagpt/v1/stat_media/get_top_musics",
          params: query,
          noCancelable: false,
          isFormData: false,
          isPyRequest: true,
          isFPyRequest: false,
        })
      );

      /**
       * 视频发布时长
       * @type {Promise<DefaultResponseType>}
       */
      const get_video_duration_stats = axios_(
        ...Object.values({
          method: "GET",
          url: "api/pandagpt/v1/stat_media/get_video_duration_stats",
          params: query,
          noCancelable: false,
          isFormData: false,
          isPyRequest: true,
          isFPyRequest: false,
        })
      );

      /**
       * 提及最多的URL
       * @type {Promise<DefaultResponseType>}
       */
      const get_top_url_mentions = axios_(
        ...Object.values({
          method: "GET",
          url: "api/pandagpt/v1/stat_media/get_top_url_mentions",
          params: query,
          noCancelable: false,
          isFormData: false,
          isPyRequest: true,
          isFPyRequest: false,
        })
      );

      /**
       * 视频发布时段
       * @type {Promise<DefaultResponseType>}
       */
      const video_release_timing = axios_(
        ...Object.values({
          method: "GET",
          url: "api/pandagpt/v1/stat_media/tiktok_video_release_timing",
          params: query,
          noCancelable: false,
          isFormData: false,
          isPyRequest: true,
          isFPyRequest: false,
        })
      );
      const promiseList = [
        get_top_hashtags,
        get_top_musics,
        get_top_mentioned_users,
        get_top_url_mentions,
        get_video_duration_stats,
        video_release_timing,
      ];

      const resList = await Promise.all(promiseList);
      if (resList.every((res) => res.code === 1)) {
        return {
          get_top_hashtags: resList[0].data,
          get_top_musics: resList[1].data,
          get_top_mentioned_users: resList[2].data,
          get_top_url_mentions: resList[3].data,
          get_video_duration_stats: resList[4].data,
          video_release_timing: resList[5].data,
        };
      } else {
        throw new Error(JSON.stringify(resList));
      }
    },
    /**
     * 导出创作偏好报表
     */
    export_creative_preferences(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/stat_media/export_creative_preferences?${qs.stringify(query)}`;
      window.open(url);
    },
  },
  tiktok_signal_post_page: {
    /**
     * tiktok单一贴文列表
     * @returns {Promise<DefaultResponseType>}
     */
    search_tiktok_posts(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/search_tiktok_posts",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * 单一帖文列表导出
     * @param query
     * @returns {Promise<*|undefined>}
     */
    export_post_list(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/stat_media/export_tiktok_single_post_list?${qs.stringify(query)}`;
      window.open(url);
    },

    /**
     * 单一贴文 数据预览
     */
    get_video_data_overview(query) {
      let config = {
        method: "GET",
        // TikTok 单一帖文数据概览使用新接口，入参只需要 page_id 和 post_id。
        url: "api/pandagpt/v1/stat_media/get_video_data_overview",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * 单一贴文 观众类型
     */
    get_video_audience_type(query) {
      let config = {
        method: "GET",
        // TikTok 单一帖文观众类型接口返回 follower 和 viewer 两组环图数据。
        url: "api/pandagpt/v1/stat_media/get_video_audience_type",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * 单一贴文 观众性别
     */
    get_video_audience_gender(query) {
      let config = {
        method: "GET",
        // TikTok 单一帖文观众性别接口返回女性、男性、其他占比。
        url: "api/pandagpt/v1/stat_media/get_video_audience_gender",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * 单一贴文 评论分析
     */
    get_video_comment_analysis(query) {
      let config = {
        method: "GET",
        // TikTok 单一帖文评论分析接口返回评论总数和情绪占比。
        url: "api/pandagpt/v1/stat_media/get_video_comment_analysis",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * 单一贴文 观众国家/地区
     */
    get_video_audience_country(query) {
      let config = {
        method: "GET",
        // TikTok 单一帖文观众国家/地区接口返回国家名称和占比。
        url: "api/pandagpt/v1/stat_media/get_video_audience_country",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * 单一贴文 流量来源
     */
    get_video_traffic_source(query) {
      let config = {
        method: "GET",
        // TikTok 单一帖文流量来源接口返回来源名称和占比。
        url: "api/pandagpt/v1/stat_media/get_video_traffic_source",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * 单一贴文 观众留存率
     */
    get_video_audience_retention(query) {
      let config = {
        method: "GET",
        // TikTok 单一帖文观众留存率接口返回流失时间和按秒留存趋势。
        url: "api/pandagpt/v1/stat_media/get_video_audience_retention",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * 单一贴文 互动占比
     */
    get_video_interaction_distribution(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/stat_media/get_video_interaction_distribution",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
  },
  ins_main_page: {
    /**
     * INS 主页千粉互动
     * @param {{page_id:string; start_date:string; end_date:string; data_type:string; period?:number}} query
     * @param query.data_type 数据类型：1 授权数据、2 公开数据
     * @param query.period 页面日/周/月筛选透传参数，便于后端按相同维度返回数据
     * @return {Promise<*|undefined>}
     */
    interaction_per_1000_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_page/interaction_per_1000_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * INS 主页内容互动次数
     * @param {{page_id:string; start_date:string; end_date:string; period:number}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<*|undefined>}
     */
    interaction_count_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_page/interaction_count_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * INS 主页互动类型
     * @param {{page_id:string; start_date:string; end_date:string; period:number}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<*|undefined>}
     */
    interaction_type_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_page/interaction_type_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * INS 主页互动用户数
     * @param {{page_id:string; start_date:string; end_date:string; period:number}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<*|undefined>}
     */
    interaction_user_count_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_page/interaction_user_count_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Ins 主页关注用户
     * @param {{page_id:string; start_date:string; end_date:string; period:string}} query
     * @return {Promise<*|undefined>}
     */
    home_page_follow_users(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_page/home_page_follow_users",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * INS 主页浏览量与覆盖人数
     * @param {{page_id:string; start_date:string; end_date:string; data_type:number; period:string;}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @param query.data_type 指标类型：1 浏览量、2 覆盖人数
     * @return {Promise<*|undefined>}
     */
    home_page_views(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_page/home_page_views",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * INS 主页数据详情
     * @param {{page_id:string; start_date:string; end_date:string; sort_field?:string; sort_order?:string; page?:number; page_num?:number}} query
     * @param query.sort_order 排序方式：asc 升序、desc 降序
     * @return {Promise<*|undefined>}
     */
    data_detail(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_page/data_detail",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * INS 主页数据详情导出
     * @param {{page_id:string; start_date:string; end_date:string; sort_field?:string; sort_order?:string}} query
     * @return {void} 在新窗口发起当前筛选条件下的报表下载。
     */
    export_data_detail(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/instagram_page/export_data_detail?${qs.stringify(query)}`;
      window.open(url);
    },
  },
  ins_fans: {
    /**
     * INS 粉丝数据 - 粉丝数
     * @param {{page_id:string; start_date:string; end_date:string; period:string}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType>}
     */
    fans_numbers(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_fans/fans_numbers",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 粉丝数据-国家分布
     * @param {{page_id:string; start_date:string; end_date:string;}} query
     * @return {Promise<DefaultResponseType>}
     */
    page_fans_country(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_fans/page_fans_country",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 粉丝数据中的国家分布数据导出
     * @param {{page_id:string; start_date:string; end_date:string; token?:string}} query
     */
    export_page_fans_country(query) {
      const baseURL = process.env.VUE_APP_PY_CN_API_URL;
      query.token = localStorage.getItem("token") || "";
      window.open(`${baseURL}api/pandagpt/v1/m/instagram_fans/export_page_fans_country?${qs.stringify(query)}`);
    },

    /**
     * Instagram 粉丝数据中的城市分布数据
     * @param {{page_id:string; start_date:string; end_date:string;}} query
     * @return {Promise<DefaultResponseType>}
     */
    page_fans_city(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_fans/page_fans_city",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 粉丝数据中的在线时间数据导出
     * @param {{page_id:string; start_date:string; end_date:string; token?:string}} query
     * @return {void} 在新窗口导出当前主页和日期范围的在线时段数据。
     */
    export_page_fans_city(query) {
      const baseURL = process.env.VUE_APP_PY_CN_API_URL;
      query.token = localStorage.getItem("token") || "";
      window.open(`${baseURL}api/pandagpt/v1/m/instagram_fans/export_page_fans_city?${qs.stringify(query)}`);
    },

    /**
     * Instagram 粉丝数据中的性别分布
     * @param {{page_id:string; start_date:string; end_date:string;}} query
     * @return {Promise<DefaultResponseType>}
     */
    page_fans_gender(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_fans/page_fans_gender",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 粉丝数据中的年龄分布
     * @param {{page_id:string; start_date:string; end_date:string;}} query
     * @return {Promise<DefaultResponseType>}
     */
    page_fans_age(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_fans/page_fans_age",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 粉丝数据中的在线时间
     * @param {{page_id:string; start_date:string; end_date:string;}} query
     * @return {Promise<DefaultResponseType>}
     */
    page_fans_online(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_fans/page_fans_online",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 主页详情中的城市分布数据导出
     * @param {{page_id:string; start_date:string; end_date:string; token?:string}} query
     */
    export_page_fans_online(query) {
      const baseURL = process.env.VUE_APP_PY_CN_API_URL;
      query.token = localStorage.getItem("token") || "";
      window.open(`${baseURL}api/pandagpt/v1/m/instagram_fans/export_page_fans_online?${qs.stringify(query)}`);
    },

    /**
     * Instagram 粉丝数据中的数据详情
     * @param {{page_id:string; start_date:string; end_date:string; page?:number; page_num?:number; sort_field?:string; sort_order?:'asc'|'desc'|''}} query
     * @return {Promise<DefaultResponseType>} 返回粉丝总数、新增、取消和净增的日期明细。
     */
    data_detail(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_fans/data_detail",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 粉丝数据中的数据详情导出
     * @param {{page_id:string; start_date:string; end_date:string; sort_field?:string; sort_order?:'asc'|'desc'|''; token?:string}} query
     * @return {void} 在新窗口导出当前主页、时间范围和排序条件下的粉丝明细。
     */
    export_data_detail(query) {
      const baseURL = process.env.VUE_APP_PY_CN_API_URL;
      query.token = localStorage.getItem("token") || "";
      window.open(`${baseURL}api/pandagpt/v1/m/instagram_fans/export_data_detail?${qs.stringify(query)}`);
    },
  },
  ins_posts: {
    /**
     * @typedef {Object} PostList
     * @property {number} carousel_album_count
     * @property {number} img_count
     * @property {number} reels_count
     * @property {number} video_count
     * @property {string} date
     */
    /**
     * @typedef {Object} Summary
     * @property {number} carousel_album_count
     * @property {number} img_count
     * @property {number} post_count
     * @property {number} reels_count
     * @property {number} video_count
     */
    /**
     * Instagram 贴文数据-发帖数
     * @param {{page_id:string; start_date:string; end_date:string; period:string}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType<{summary:Summary; post_list:PostList[]} | never[]>>}
     */
    post_count_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_post/post_count_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 帖子数据-帖文互动数
     * @param {{page_id:string; start_date:string; end_date:string; period:string; data_type:string}} query
     * @return {Promise<DefaultResponseType<{summary:Record<string,number>; engagements_list:Record<string, number|string>[]}|never[]>>}
     */
    post_engagements(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_post/post_engagements",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 帖子数据帖文互动趋势
     * @param {{page_id:string; start_date:string; end_date:string; period:string; data_type:string}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @param query.data_type 数据类型：1 授权数据、2 公开数据
     * @return {Promise<DefaultResponseType<{summary:{post_total:number;engagements_total:number}; engagements_list:{date:string;post_count:number;engagements_count:number}[]} | []>>}
     */
    post_count_and_engagements(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_post/post_count_and_engagements",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 帖子数据-使用话题数量
     * @param {{page_id:string; start_date:string; end_date:string; period:string;}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType>}
     */
    post_topics_count(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_post/post_topics_count",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Instagram 帖子数据-帖文曝光次数
     * @param {{page_id:string; start_date:string; end_date:string; period:string;}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType<[]|{summary:Record<string, string|number>; data_list:Record[]}>>}
     */
    post_views(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_post/post_views",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 帖子数据-帖文覆盖次数
     * @param {{page_id:string; start_date:string; end_date:string; period:string;}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType<[]|{summary:Record<string, string|number>; data_list:Record[]}>>}
     */
    post_reach(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_post/post_reach",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 帖子数据-帖文收藏数
     * @param {{page_id:string; start_date:string; end_date:string; period:string;}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType>}
     */
    post_saved(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_post/post_saved",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 帖子数据-轮播图相册
     * @param {{page_id:string; start_date:string; end_date:string; period:string;}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType<{summary:Record<string,number>; engagements_list:Record[]}|[]>>}
     */
    carousel_album_data(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_post/carousel_album_data",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 帖子数据-视频观看
     * @param {{page_id:string; start_date:string; end_date:string; period:string;}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType<{summary:Record<string,number>; data_list:Record[]}|[]>>}
     */
    post_video_views(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_post/post_video_views",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 帖子数据-评论趋势
     * @param {{page_id:string; start_date:string; end_date:string; period:string;}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType<[]|{summary:Record<string, number>; comment_trend_list:Record[]}>>}
     */
    comment_trend(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_post/comment_trend",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 帖子数据-数据详情
     * @param {{page_id:string; start_date:string; end_date:string; page:number; page_num:number; sort_field?:string; sort_order?:'asc'|'desc'|''}} query
     * @return {Promise<DefaultResponseType<{data:Record[];total:number}>>}
     */
    data_detail(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_post/data_detail",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * Instagram 帖子数据详情导出
     * @param {{page_id:string; start_date:string; end_date:string; sort_field?:string; sort_order?:'asc'|'desc'|''; token?:string}} query
     * @return {void} 在新窗口导出当前主页、日期范围和排序条件下的帖子数据详情。
     */
    export_data_detail(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/instagram_post/export_data_detail?${qs.stringify(query)}`;

      window.open(url);
    },
  },
  ins_reels: {
    /**
     * @typedef {Object} PostList
     * @property {string} date 日期
     * @property {number} img_count 图片
     * @property {number} video_count 视频
     */
    /**
     * @typedef {Object} Summary
     * @property {number} post_count_sum 发帖总数
     * @property {number} img_count_sum 图片总数
     * @property {number} video_count_sum 视频总数
     */
    /**
     * Instagram 快拍数据-快拍数
     * @param {{page_id:string; start_date:string; end_date:string; period:string}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType<{summary:Summary; post_list:PostList[]} | never[]>>}
     */
    story_count_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_story/story_count_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Instagram 快拍数据-浏览量
     * @param {{page_id:string; start_date:string; end_date:string; period:string}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType<{summary:{exposure_total:number;max_exposure:number;max_exposure_date:string;min_exposure:number;min_exposure_date:string}; data_list:{date:string;num:number|string}[]} | never[]>>}
     */
    story_views(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_story/story_views",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Instagram 快拍数据-覆盖人数
     * @param {{page_id:string; start_date:string; end_date:string; period:string}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType<{summary:{coverage_total:number;max_coverage:number;max_coverage_date:string;min_coverage:number;min_coverage_date:string}; data_list:{date:string;num:number|string}[]} | never[]>>}
     */
    story_reach(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_story/story_reach",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Instagram 快拍数据-快拍单条覆盖人数
     * @param {{page_id:string; start_date:string; end_date:string; period:string}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType<{summary:{coverage_total:number;max_coverage:number;max_coverage_date:string;min_coverage:number;min_coverage_date:string}; data_list:{date:string;num:number|string}[]} | never[]>>}
     */
    story_single_reach(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_story/story_single_reach",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Instagram 快拍数据-快拍完播率
     * @param {{page_id:string; start_date:string; end_date:string; period:string}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType<{summary:{max_completion_rate:number|string;max_completion_rate_date:string;min_completion_rate:number|string;min_completion_rate_date:string}; data_list:{date:string;num:number|string}[]} | never[]>>}
     */
    story_completion_rate(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_story/story_completion_rate",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Instagram 快拍数据-回复次数
     * @param {{page_id:string; start_date:string; end_date:string; period:string}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType<{summary:{reply_num_total:number;max_reply_num:number;max_reply_num_date:string;min_reply_num:number;min_reply_num_date:string}; data_list:{date:string;num:number|string}[]} | never[]>>}
     */
    reply_num(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_story/reply_num",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Instagram 快拍数据-退出次数
     * @param {{page_id:string; start_date:string; end_date:string; period:string}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType<{summary:{exits_num_total:number;max_exits_num:number;max_exits_num_date:string;min_exits_num:number;min_exits_num_date:string}; data_list:{date:string;num:number|string}[]} | never[]>>}
     */
    exits_num(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_story/exits_num",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Instagram 快拍数据-轻触前进/返回次数
     * @param {{page_id:string; start_date:string; end_date:string; period:string}} query
     * @param query.period 时间维度：1 日、2 周、3 月
     * @return {Promise<DefaultResponseType<{summary:{forward_or_return_times_total:number;image_forward_or_return_times_total:number;video_forward_or_return_times_total:number}; forward_or_return_times_list:{date:string;image_forward_or_return_times:number;video_forward_or_return_times:number}[]} | never[]>>}
     */
    forward_or_return_times(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_story/forward_or_return_times",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
  },
  ins_signal_post_page: {
    /**
     * Instagram 帖子列表
     * @param {{page_id:string;start_date:string;end_date:string;page:number;page_num:number;sort_field?:string;sort_order?:'asc'|'desc'|'';type?:string;post_status?:string;post_content?:string;post_type?:string}} query
     * @return {Promise<DefaultResponseType<{data:Record[];total:number}>>}
     */
    post_list(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_single_post/post_list",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Instagram  快拍列表
     */
    story_post_list(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_single_post/story_post_list",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * Instagram 帖子导出
     */
    export_post_list(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/instagram_single_post/export_post_list?${qs.stringify(query)}`;
      window.open(url);
    },
    /**
     * Instagram 快拍导出
     */
    export_story_post_list(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/instagram_single_post/export_story_post_list?${qs.stringify(query)}`;
      window.open(url);
    },
    /**
     * Instagram 单一贴文数据详情 帖文数据
     * @param {{page_id:string;post_id:string;data_type:'1'|'2'}} query
     * @return {Promise<DefaultResponseType<{result:Record}>>}
     */
    post_details(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/instagram_single_post/post_details",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
  },

  twitter_main_page: {
    /**
     * X 主页千粉互动；X 主页 ID 可能超出 JavaScript 安全整数范围，因此调用方可保持字符串传参。
     * @param {{page_id:string|number; start_date:string;end_date:string;period:1|2|3;data_type?:'1'|'2'}} query
     * @param query.data_type 数据口径：1 授权数据，2 公开数据；未传时由服务端按默认公开口径处理
     * @return {Promise<DefaultResponseType<[]|{summary:Record<string,string>; data_list:{date:string;num:string}[]}>>}
     */
    interaction_per_1000_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_page/interaction_per_1000_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * X 主页单帖互动；X 主页 ID 可能超出 JavaScript 安全整数范围，因此调用方可保持字符串传参。
     * @param {{page_id:string|number; start_date:string;end_date:string;period:1|2|3}} query
     * @return {Promise<DefaultResponseType<[]|{summary:Record<string,string>; data_list:{date:string;num:string}[]}>>}
     */
    post_interaction_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_page/post_interaction_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * 推特主页关注用户
     * @param {{page_id:string; start_date:string;end_date:string;period:string}} query
     * @return {Promise<DefaultResponseType<[]|{summary:Record<string,string>; line_data:{following_net_growth:number;date:string;following_count:number}[]}>>}
     */
    page_following_users(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_page/page_following_users",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * 推特主页主页所属列表
     * @param {{page_id:string; start_date:string;end_date:string;period:string}} query
     * @return {Promise<DefaultResponseType<[]|{summary:Record<string,string>; line_data:{listed_count:number;date:string;listed_net_growth:number}[]}>>}
     */
    page_lists_data(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_page/page_lists_data",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
  },
  twitter_fans: {
    /**
     * X 主页详情中的粉丝趋势数据
     * @param {{page_id:string; start_date:string;end_date:string;period:string}} query
     * @return {Promise<DefaultResponseType<[]|{summary:Record<string,string>;follows_list:Array<{date:string;follows_grand_total:number;follows_reality:number;}>}>>}
     */
    page_follows_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_follows/page_follows_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * X 主页详情中的粉丝趋势数据
     * @param {{
     *    page_id:string;
     *    start_date:string;
     *    end_date:string;
     *    page:number;
     *    page_num:number;
     *    sort_field:string;
     *    sort_order:string;
     * }} query
     * @return {Promise<DefaultResponseType>}
     */
    data_detail(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_follows/data_detail",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * tiktok主页详情导出
     * @param {{page_id:string;start_date:string;end_date:string;[k:string]:any}} query
     */
    export_data_detail(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/twitter_follows/export_data_detail?${qs.stringify(query)}`;
      window.open(url);
    },
  },
  twitter_posts: {
    /**
     * twitter 帖文互动
     * @param {{
     *     page_id:string;
     *     start_data:string;
     *     end_date:string;
     *     period:string;
     *     data_type:string;
     * }} query
     * @return {Promise<DefaultResponseType<[]|{summary:Record; engagements_list:Record[]}>>}
     */
    post_engagements(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_posts/post_engagements",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * twitter 发帖数
     * @param {{
     *     page_id:string;
     *     start_date:string;
     *     end_date:string;
     *     period:string;
     * }} query
     * @return {Promise<DefaultResponseType<[]|{summary:Record; post_list:Record[]}>>}
     */
    post_count_query(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_posts/post_count_query",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * twitter 帖文曝光
     * @param {{
     *     page_id:string;
     *     start_data:string;
     *     end_date:string;
     *     period:string;
     * }} query
     * @return {Promise<DefaultResponseType<[]|{summary:Record; impressions_list:Record[]}>>}
     */
    post_impressions(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_posts/post_impressions",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * twitter 发帖及帖文互动趋势
     * @param {{
     *     page_id:string;
     *     start_date:string;
     *     end_date:string;
     *     period:string;
     *     data_type:string;
     * }} query
     * @return {Promise<DefaultResponseType<[]|{summary:Record; engagements_list:Record[]}>>}
     */
    post_count_and_engagements(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_posts/post_count_and_engagements",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * twitter 视频观看次数
     * @param {{
     *     page_id:string;
     *     start_date:string;
     *     end_date:string;
     * }} query
     * @return {Promise<DefaultResponseType<[]|{summary:Record; post_video_views_list:Record[]}>>}
     */
    post_video_views(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_posts/post_video_views",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * twitter 帖文类型
     * @param {{
     *     page_id:string;
     *     start_date:string;
     *     end_date:string;
     *     period:string;
     * }} query
     * @return {Promise<DefaultResponseType<[]|{summary:Record; type_list:Record[]}>>}
     */
    post_type(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_posts/post_type",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * twitter 评论趋势
     * @param {{
     *     page_id:string;
     *     start_date:string;
     *     end_date:string;
     * }} query
     * @return {Promise<DefaultResponseType<[]|{summary:Record; comment_trend_list:Record[]}>>}
     */
    comment_trend(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_posts/comment_trend",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * twitter 帖文表格
     * @param {{
     *     page_id:string;
     *     start_date:string;
     *     end_date:string;
     *     page:number;
     *     page_num:number;
     *     sort_field:string;
     *     sort_order:string;
     * }} query
     * @return {Promise<DefaultResponseType<{data:Record[]; total:number}>>}
     */
    data_detail(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_posts/data_detail",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * X 帖子数据详情导出；浏览器直开下载请求需要将签名放入 query，不能只拼接 token。
    * @param {{page_id:string;start_date:string;end_date:string;[k:string]:any}} query
     */
    export_data_detail(query) {
      // 导出路由必须与 data_detail 同属 /m/twitter_posts 命名空间，避免请求落到旧接口而触发错误签名校验。
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/twitter_posts/export_data_detail`;
      exportWithSign(url, query);
    },
  },
  twitter_signal_post: {
    /**
     * @typedef {Object} PostListQuery
     * @property {string} page_id
     * @property {string} start_date
     * @property {string} end_date
     * @property {number} page
     * @property {number} page_num
     * @property {string} sort_field
     * @property {string} sort_order
     * @property {number} type
     * @property {number} post_status
     * @property {string} text
     * @property {string} referenced_tweets_type 原创状态：original=原创，retweeted=转发，replied_to=回复
     */
    /**
     * 单一贴文列表
     * @param {PostListQuery} query
     * @return {Promise<DefaultResponseType<{data:Record; total:number}>>}
     */
    post_list(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_single_posts/post_list",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },

    /**
     * 导出 X 单一帖子列表，参数与 post_list 保持一致以复用当前列表的筛选和排序条件。
     * @param {PostListQuery} query
     */
    export_post_list(query) {
      const baseURL = process.env.VUE_APP_PY_CN_API_URL;
      query.token = localStorage.getItem("token") || "";
      const url = `${baseURL}api/pandagpt/v1/m/twitter_single_posts/export_post_list?${qs.stringify(query)}`;
      window.open(url);
    },
  },
  twitter_signal_post_detail: {
    /**
     * twitter 单一帖文详情帖文占比总数
     * @param {{page_id:string; post_id:string}} query
     * @return {Promise<DefaultResponseType>}
     */
    post_engagements_rate(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_posts_detail/post_engagements_rate",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
    /**
     * twitter 单一帖文详情数据概览
     * @param {{page_id:string; post_id:string}} query
     * @return {Promise<DefaultResponseType>}
     */
    data_summarize(query) {
      let config = {
        method: "GET",
        url: "api/pandagpt/v1/m/twitter_posts_detail/data_summarize",
        params: query,
        noCancelable: false,
        isFormData: false,
        isPyRequest: true,
        isFPyRequest: false,
      };
      return axios_(...Object.values(config));
    },
  },
  youtube_main_page: {
    /**
     * 主页千粉互动
     * @param {{
     *   page_id:string;
     *   start_date:string;
     *   end_date:string;
     *   period:string;
     * }} query
     * @return {Promise<DefaultResponseType<{data_list:Array; summary:Record}>>}
     */
    interaction_per_1000_query(query) {
      const config = useConfig("GET", "api/pandagpt/v1/m/youtube_page/interaction_per_1000_query", query);
      return axios_(...Object.values(config));
    },

    /**
     * 主页单贴互动
     * @param {{
     *   page_id:string;
     *   start_date:string;
     *   end_date:string;
     *   period:string;
     * }} query
     * @return {Promise<DefaultResponseType<{data_list:Array; summary:Record}>>}
     */
    post_interaction_query(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/m/youtube_page/post_interaction_query", query)));
    },

    /**
     * 主页数据详情
     * @param {{
     *   page_id:string;
     *   start_date:string;
     *   end_date:string;
     *   page:number;
     *   page_num:number;
     *   sort_field:string;
     *   sort_order:string;
     * }} query
     * @return {Promise<DefaultResponseType<{data:Array<Record>; total:number}>>}
     */
    data_detail(query) {
      return axios_(...Object.values(useConfig("GET", `api/pandagpt/v1/m/youtube_page/data_detail`, query)));
    },
    /**
     * 主页数据详情导出
     * @param {{page_id:string; start_date:string;end_date:string;sort_field:string;sort_order:string;}} query
     */
    export_data_detail(query) {
      useExport("api/pandagpt/v1/m/youtube_page/export_data_detail", query);
    },
  },
  youtube_fans: {
    /**
     * 粉丝数
     * @param {{
     *   page_id:string;
     *   start_date:string;
     *   end_date:string;
     *   period:string;
     * }} query
     * @return {Promise<DefaultResponseType<{follow_list:Array; summary:Record<string,any>}>>}
     */
    fans_numbers(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/m/youtube_fans/fans_numbers", query)));
    },
    /**
     * 粉丝数据详情
     * @param {{
     *   page_id:string;
     *   start_date:string;
     *   end_date:string;
     *   page:number;
     *   page_num:number;
     *   sort_field:string;
     *   sort_order:string;
     * }} query
     * @return {Promise<DefaultResponseType<{data:Array<Record>; total:number}>>}
     */
    data_detail(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/m/youtube_fans/data_detail", query)));
    },

    /**
     * 粉丝数据详情导出
     * @param {{
     *   page_id:string;
     *   start_date:string;
     *   end_date:string;
     *   sort_field:string;
     *   sort_order:string;
     * }} query
     */
    export_data_detail(query) {
      useExport("api/pandagpt/v1/m/youtube_fans/export_data_detail", query);
    },
  },
  youtube_videos: {
    /**
     * 获取视频数
     * @param {{
     *   page_id:string;
     *   start_date:string;
     *   end_date:string;
     *   period:string;
     * }} query
     * @returns {Promise<DefaultResponseType<{data_list:Array<Record<string, any>>; summary:Record<string,any>}>>}
     */
    video_data(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/m/youtube_video/video_data", query)));
    },
    /**
     * 获取视频观看数
     * @param {{
     *   page_id:string;
     *   start_date:string;
     *   end_date:string;
     *   period:string;
     * }} query
     * @returns {Promise<DefaultResponseType<{data_list:Array<Record<string, any>>; summary:Record<string,any>}>>}
     */
    video_views_data(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/m/youtube_video/video_views_data", query)));
    },
    /**
     * 获取视频互动数
     * @param {{
     *   page_id:string;
     *   start_date:string;
     *   end_date:string;
     *   period:string;
     * }} query
     * @returns {Promise<DefaultResponseType<{data_list:Array<Record<string, any>>; summary:Record<string,any>}>>}
     */
    video_interactions_data(query) {
      return axios_(
        ...Object.values(useConfig("GET", "api/pandagpt/v1/m/youtube_video/video_interactions_data", query))
      );
    },

    /**
     * 粉丝数据详情
     * @param {{
     *   page_id:string;
     *   start_date:string;
     *   end_date:string;
     *   page:number;
     *   page_num:number;
     *   sort_field:string;
     *   sort_order:string;
     * }} query
     * @return {Promise<DefaultResponseType<{data:Array<Record>; total:number}>>}
     */
    data_detail(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/m/youtube_video/data_detail", query)));
    },
    /**
     * 数据详情导出
     * @param {{
     *   page_id:string;
     *   start_date:string;
     *   end_date:string;
     *   sort_field:string;
     *   sort_order:string;
     * }} query
     */
    export_data_detail(query) {
      useExport("api/pandagpt/v1/m/youtube_video/export_data_detail", query);
    },
  },
  youtube_signal_post: {
    /**
     * 获取youtube单一视频列表
     * @param {{
     *   page_id:string;
     *   start_date:string;
     *   end_date:string;
     *   page:number;
     *   page_num:number;
     *   sort_field:string;
     *   sort_order:string;
     *   type:"1"|"2";
     *   is_del:0|1;
     *   text:string;
     * }} query
     * @returns {Promise<DefaultResponseType<{data:Array<Record>;total:number}>>}
     */
    single_video_data(query) {
      return axios_(
        ...Object.values(useConfig("GET", "api/pandagpt/v1/m/youtube_single_video/single_video_data", query))
      );
    },
    /**
     * youtube 视频列表导出
     * @param {{
     *   post_id:string;
     *   start_date:string;
     *   end_date:string;
     *   sort_field:string;
     *   sort_order:string;
     *   type:string;
     *   text:string;
     *   video_ids:string[]
     * }} query
     */
    export_single_video_list(query) {
      useExport("api/pandagpt/v1/m/youtube_single_video/export_single_video_list", query);
    },
  },
  youtube_signal_post_detail: {
    /**
     * 获取单一视频详情的数据概览
     * @param {{page_id:string; post_id:string}} query 使用单一帖子列表返回的 post_id。
     * @return {Promise<DefaultResponseType<Record<string,number>>>}
     */
    data_summarize(query) {
      return axios_(
        ...Object.values(useConfig("GET", "api/pandagpt/v1/m/youtube_single_detail_video/data_summarize", query))
      );
    },
    /**
     * 帖文互动占比
     * @param {{page_id:string; post_id:string}} query 与数据概览使用相同的帖子标识。
     * @return {Promise<DefaultResponseType<Record<string,number>>>}
     */
    post_engagements_rate(query) {
      const requestURL = "api/pandagpt/v1/m/youtube_single_detail_video/post_engagements_rate";
      return axios_(...Object.values(useConfig("GET", requestURL, query)));
    },
  },

  // #region ----------------------------- Telegram START --------------------------

  Telegram_main_page: {
    /**
     * 主页千粉互动
     * @param {{
     *   page_id:number;
     *   start_date:string;
     *   end_date:string;
     *   period:number;
     * }} query
     * @return {Promise<DefaultResponseType<{data_list:Array; summary:Record}>>}
     */
    interaction_per_1000_query(query) {
      const config = useConfig("GET", "api/pandagpt/v1/m/telegram_page/interaction_per_1000_query", query);
      return axios_(...Object.values(config));
    },

    /**
     * 主页单贴互动
     * @param {{
     *   page_id:number;
     *   start_date:string;
     *   end_date:string;
     *   period:number;
     * }} query
     * @return {Promise<DefaultResponseType<{data_list:Array; summary:Record}>>}
     */
    post_interaction_query(query) {
      return axios_(
        ...Object.values(useConfig("GET", "api/pandagpt/v1/m/telegram_page/post_interaction_query", query))
      );
    },

    /**
     * 主页数据详情
     * @param {{
     *   page_id:number;
     *   start_date:string;
     *   end_date:string;
     *   page:number;
     *   page_num:number;
     *   sort_field:string;
     *   sort_order:string;
     * }} query
     * @return {Promise<DefaultResponseType<{data:Array<Record>; total:number}>>}
     */
    data_detail(query) {
      return axios_(
        ...Object.values(useConfig("GET", `api/pandagpt/v1/m/telegram_page/interaction_data_detail`, query))
      );
    },
    /**
     * 主页数据详情导出
     * @param {{page_id:number; start_date:string;end_date:string;sort_field:string;sort_order:string;}} query
     */
    export_data_detail(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/telegram_page/export_interaction_data?${qs.stringify(query)}`;
      window.open(url);
    },
  },
  Telegram_fans: {
    /**
     * 粉丝数
     * @param {{
     *   page_id:number;
     *   start_date:string;
     *   end_date:string;
     *   period:string;
     * }} query
     * @return {Promise<DefaultResponseType<{follow_list:Array; summary:Record<string,any>}>>}
     */
    fans_numbers(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/m/telegram_fans/fans_numbers", query)));
    },
    /**
     * 粉丝数据详情
     * @param {{
     *   page_id:number;
     *   start_date:string;
     *   end_date:string;
     *   page:number;
     *   page_num:number;
     *   sort_field:string;
     *   sort_order:string;
     * }} query
     * @return {Promise<DefaultResponseType<{data:Array<Record>; total:number}>>}
     */
    data_detail(query) {
      return axios_(...Object.values(useConfig("GET", "/api/pandagpt/v1/m/telegram_fans/fans_data_detail", query)));
    },

    /**
     * 粉丝数据详情导出
     * @param {{
     *   page_id:number;
     *   start_date:string;
     *   end_date:string;
     *   sort_field:string;
     *   sort_order:string;
     * }} query
     */
    export_fans_data(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/telegram_fans/export_fans_data?${qs.stringify(query)}`;
      window.open(url);
    },
  },
  Telegram_post: {
    /**
     * 获取发帖数
     * @param {{
     *   page_id:number;
     *   start_date:string;
     *   end_date:string;
     *   period:string;
     * }} query
     * @returns {Promise<DefaultResponseType<{data_list:Array<Record<string, any>>; summary:Record<string,any>}>>}
     */
    post_data(query) {
      return axios_(...Object.values(useConfig("GET", "/api/pandagpt/v1/m/telegram_post/post_data", query)));
    },
    /**
     * 获取 互动次数
     * @param {{
     *   page_id:number;
     *   start_date:string;
     *   end_date:string;
     *   period:string;
     * }} query
     * @returns {Promise<DefaultResponseType<{data_list:Array<Record<string, any>>; summary:Record<string,any>}>>}
     */
    post_interaction_data(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/m/telegram_post/post_interaction_data", query)));
    },
    /**
     * 获取 曝光次数
     * @param {{
     *   page_id:number;
     *   start_date:string;
     *   end_date:string;
     *   period:string;
     * }} query
     * @returns {Promise<DefaultResponseType<{data_list:Array<Record<string, any>>; summary:Record<string,any>}>>}
     */
    post_views_data(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/m/telegram_post/post_views_data", query)));
    },
    /**
     * 获取评论趋势
     * @param {{
     *   page_id:number;
     *   start_date:string;
     *   end_date:string;
     *   page:number;
     *   page_num:number;
     *   sort_field:string;
     *   sort_order:string;
     * }} query
     * @return {Promise<DefaultResponseType<{data:Array<Record>; total:number}>>}
     */
    post_comments_data(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/m/telegram_post/post_comments_data", query)));
    },

    // telegram_post/post_comments_data
    /**
     * 数据详情
     * @param {{
     *   page_id:number;
     *   start_date:string;
     *   end_date:string;
     *   page:number;
     *   page_num:number;
     *   sort_field:string;
     *   sort_order:string;
     * }} query
     * @return {Promise<DefaultResponseType<{data:Array<Record>; total:number}>>}
     */
    post_data_detail(query) {
      return axios_(...Object.values(useConfig("GET", "api/pandagpt/v1/m/telegram_post/post_data_detail", query)));
    },
    /**
     * 数据详情导出
     * @param {{
     *   page_id:string;
     *   start_date:string;
     *   end_date:string;
     *   sort_field:string;
     *   sort_order:string;
     * }} query
     */
    export_post_data(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/telegram_post/export_post_data?${qs.stringify(query)}`;
      window.open(url);
    },
  },
  Telegram_signal_post: {
    /**
     * 获取telegram单一帖文列表
     * @param {{
     *   page_id:number;
     *   start_date:string;
     *   end_date:string;
     *   page:number;
     *   page_num:number;
     *   sort_field:string;
     *   sort_order:string;
     *   is_del:0|1;
     *   text:string;
     * }} query
     * @returns {Promise<DefaultResponseType<{data:Array<Record>;total:number}>>}
     */
    single_post_data(query) {
      return axios_(
        ...Object.values(useConfig("GET", "/api/pandagpt/v1/m/telegram_single_post/single_post_data", query))
      );
    },
    /**
     * telegram 帖文列表导出
     * @param {{
     *   post_id:string;
     *   start_date:string;
     *   end_date:string;
     *   sort_field:string;
     *   sort_order:string;
     *   type:string;
     *   text:string;
     *   video_ids:string[]
     * }} query
     */
    export_single_post(query) {
      query.token = localStorage.getItem("token") || "";
      const url = `${process.env.VUE_APP_PY_CN_API_URL}api/pandagpt/v1/m/telegram_single_post/export_single_post?${qs.stringify(query)}`;
      window.open(url);
    },
  },
  Telegram_signal_post_detail: {
    /**
     * 获取单一帖子的详情数据
     * @param {{page_id:number; post_id:number}} query
     * @return {Promise<DefaultResponseType<Record<string,number>>>}
     */
    post_data_detail(query) {
      return axios_(
        ...Object.values(useConfig("GET", "/api/pandagpt/v1/m/telegram_single_post/single_post_data_detail", query))
      );
    },
    // /**
    //  * 帖文互动占比
    //  * @param {{page_id:string; video_id:string}} query
    //  * @return {Promise<DefaultResponseType<Record<string,number>>>}
    //  */
    // post_engagements_rate(query) {
    //   const requestURL = "api/pandagpt/v1/m/youtube_single_detail_video/post_engagements_rate";
    //   return axios_(...Object.values(useConfig("GET", requestURL, query)));
    // },
  },
  // #endregion -------------------------- Telegram END ----------------------------
};
